import { useNotifyStore } from '@/stores/notify'
import { ref, Ref } from 'vue'

interface IframeControl {
  toggle:Ref<boolean>;
  updateCoreValuesOnStore(): void;
  notifyOpen(): void;
  notifyKill():void;
  notifyClose(): void;
}

const toggle = ref<boolean>(false)

export default function iframeInternalChat (): IframeControl {
  const notifyStore = useNotifyStore()

  function updateCoreValuesOnStore (): void {
    const query = new URLSearchParams(window.location.search)
    // const token = query.get('token') ?? ''
    const apiKey = query.get('apiKey') ?? 0

    if (apiKey) {
      // notifyStore.upToken(token)
      notifyStore.upBearer(apiKey)
      return
    }
    // notifyStore.upToken('sFeqqJqnlJ6ZV29nZWVubmVhV5eqqJ6jmqiolJ6ZV29rYVeYnZajo5qhlJ6ZV29nZWxssg==')
    // notifyStore.upBearer('eyJpdiI6IklkR1NJa3p5M2tYWGw3VnQ3ejNGeXc9PSIsInZhbHVlIjoickdSY2tDQkdMUi80VlA4WFZjbFNsUT09IiwibWFjIjoiYjVmY2UxMGY2YWZlZWJkNDgwZmE4MzYyOTcwNTQzYzM5YjM5NDM3OGU4MmVlODgzMTUzZjNkNzg0ZmUxMDY0NyIsInRhZyI6IiJ9')

    notifyStore.upBearer(process.env.VUE_APP_INTERNAL_CHAT_TOKEN)
  }

  function notifyOpen (): void {
    toggle.value = true
    window.parent.postMessage({
      isWidget: true,
      isOpen: true
    }, '*')
  }

  function notifyClose (): void {
    toggle.value = false
    window.parent.postMessage({
      isWidget: true,
      isOpen: false
    }, '*')
  }

  function notifyKill(): void {
    toggle.value = false
    window.parent.postMessage({
        isWidget: false,
        internalChat: 'close'
      }, '*')
  }

  return {
    toggle,
    updateCoreValuesOnStore,
    notifyOpen,
    notifyKill,
    notifyClose
  }
}
